
// String Validity Check.

export const isEmptyOrHasSpacesPattern = '^\\S*$';

//Check if string is empty or contains spaces
function isEmptyOrHasSpaces(str: string): boolean {
  if (str === undefined) {
    return true;
  }
  if (str === null) {
    return true;
  }
  if (str === '') {
    return true;
  }
  if (str.match(isEmptyOrHasSpacesPattern) === null) {
    return true;
  }
  return false;
}

// Helper Function used to identify whether the string is empty or undefined.
export const isEmptyOrSpaces = (str: string) => {
  if (str === undefined || str === null) {
    return true;
  }
  if (str === "") {
    return true;
  }
  //Somehow the param type is not enough to validate the type and .match() breaks the page if it's not a string
  if(typeof str !== "string" ){
    return true;
  }
  if (str.match(/^ *$/) !== null) {
    return true;
  }
  return false;
}

export const IsJsonString = (str: any) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const nameof = <T>(name: keyof T) => name